export default "__VITE_ASSET__B9nOmXaN__"